import { BodyDefault } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledContainer = styled.div`
  max-width: 28rem;
`

export const StyledTextBlack = styled(BodyDefault)`
  display: inline;
  color: ${({ theme }) => theme.colors.BLACK_900};
`
